module.exports = __webpack_public_path__ + "static/media/shepher_dyer_solmonte_marzinski_toward.466ad085.gif";